import { Tooltip, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { formatNumber } from '../../format';

export interface BarItem {
  key: string;
  label: string;
  sublabel?: string;
  value: number;
  to?: string;
}

/**
 * One series of horizontal bars, largest first (compare magnitude): every bar in slot 1, thin,
 * the data end rounded, the value at the tip, no legend (the card title names the series).
 */
export function BarList({
  items,
  unit,
  total,
}: {
  items: BarItem[];
  unit: string;
  total?: number;
}) {
  const max = Math.max(...items.map((i) => i.value), 0);
  return (
    <div className="wm-viz" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {items.map((item) => {
        const share = total ? Math.round((item.value / total) * 100) : null;
        const row = (
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: 8,
                alignItems: 'baseline',
              }}
            >
              <span style={{ minWidth: 0, color: 'var(--viz-text)' }}>
                {item.label}
                {item.sublabel && (
                  <Typography.Text type="secondary" style={{ fontSize: 12, marginInlineStart: 6 }}>
                    {item.sublabel}
                  </Typography.Text>
                )}
              </span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
              <div style={{ flex: 1, height: 10 }}>
                <div
                  style={{
                    width: `${max ? Math.max(2, (item.value / max) * 100) : 0}%`,
                    height: '100%',
                    background: 'var(--series-1)',
                    borderStartEndRadius: 4,
                    borderEndEndRadius: 4,
                  }}
                />
              </div>
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: 'var(--viz-text-2)',
                  whiteSpace: 'nowrap',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {formatNumber(item.value)} {unit}
              </span>
            </div>
          </div>
        );
        const tip = `${item.label} : ${formatNumber(item.value)} ${unit}${share !== null ? ` (${share} %)` : ''}`;
        return (
          <Tooltip key={item.key} title={tip}>
            {item.to ? (
              <Link to={item.to} style={{ color: 'inherit', display: 'block' }} aria-label={tip}>
                {row}
              </Link>
            ) : (
              <div aria-label={tip}>{row}</div>
            )}
          </Tooltip>
        );
      })}
    </div>
  );
}
